import { Alert, Button, Spinner } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { useGetRallyById } from "../../../../../api/jeep-rally/rally/rally.hooks";
import { isJeepRallyAdmin } from "../../Categories/utils/category.utils";
import { formatRallyDate, normalizeRally } from "../utils/rally.utils";
import RallyCategorySection from "./_components/RallyCategorySection";
import RallyHighlightsSection from "./_components/RallyHighlightsSection";
import RallyInfoSection from "./_components/RallyInfoSection";
import RallyMediaSection from "./_components/RallyMediaSection";
import RallyStatsSection from "./_components/RallyStatsSection";

const RallyViewPage = () => {
  const history = useHistory();
  const { id } = useParams();
  const canManage = isJeepRallyAdmin();

  const { data: rallyData, isLoading, isError, error } = useGetRallyById(id);
  const rally = normalizeRally(rallyData);
  const rallyId = rally?._id || rally?.id || id;

  const goBack = () => history.push("/jeep-rally/rallies");
  const goEdit = () => history.push(`/jeep-rally/rallies/edit/${rallyId}`);

  if (isLoading) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <Alert variant="danger" className="mb-3">
              {error?.response?.data?.message ||
                "Failed to load rally details."}
            </Alert>
            <Button variant="outline-secondary" onClick={goBack}>
              Back to rallies
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (!rally) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-center py-5">
            <h5 className="mb-2">Rally not found</h5>
            <p className="text-muted mb-3">
              This rally may have been deleted or the link is invalid.
            </p>
            <Button variant="outline-secondary" onClick={goBack}>
              Back to rallies
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-link p-0 text-decoration-none"
              onClick={goBack}
              aria-label="Back to rallies list"
              title="Back"
            >
              <i className="bi bi-arrow-left fs-4" />
            </button>
            <div>
              <h4 className="card-title mb-0">View Rally</h4>
              <small className="text-muted">
                Updated {formatRallyDate(rally.updated_at || rally.updatedAt)}
              </small>
            </div>
          </div>

          <div className="d-flex gap-2">
            {canManage ? (
              <Button variant="primary" size="sm" onClick={goEdit}>
                Edit
              </Button>
            ) : null}
          </div>
        </div>

        <div className="card-body">
          <RallyInfoSection rally={rally} />
          <hr className="my-4" />
          <RallyCategorySection rally={rally} />
          <hr className="my-4" />
          <RallyStatsSection rally={rally} />
          <hr className="my-4" />
          <RallyHighlightsSection highlights={rally.highlights} />
          <hr className="my-4" />
          <RallyMediaSection rally={rally} />

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="outline-secondary" onClick={goBack}>
              Back
            </Button>
            {canManage ? (
              <Button variant="primary" onClick={goEdit}>
                Edit Rally
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RallyViewPage;
